import React from 'react';
import {Input} from 'formsy-react-components';
import PropTypes from 'prop-types';
import {cleanProps} from 'formsy-react-components/release/prop-utilities';
import Icon from 'formsy-react-components/release/icon';
import Row from 'formsy-react-components/release/row';
import SafeHTML from '../fw/SafeHTML.react';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

interface _InputProps {
    addonAfter?: string | React.ReactNode;
    addonBefore?: string | React.ReactNode;
    buttonAfter?: React.ReactNode;
    buttonBefore?: React.ReactNode;
    htmlHelp?: string;
    type?: "color" | "date" | "datetime" | "datetime-local" | "email" | "hidden" | "month" | "number" | "password" | "range" | "search" | "tel" | "text" | "time" | "url" | "week";
}

export default class _Input extends Input<_InputProps> {
	static propTypes = {
		addonAfter: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		addonBefore: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        buttonAfter: PropTypes.node,
		buttonBefore: PropTypes.node,
		htmlHelp: PropTypes.string,
        type: PropTypes.oneOf(['color', 'date', 'datetime', 'datetime-local', 'email', 'hidden', 'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time', 'url', 'week']),
    };

	renderHelp = function() {
		if (this.props.htmlHelp) {
			return (
                <span className="help-block"><SafeHTML value={this.props.htmlHelp + '<br/>'} /></span>
			);
		}

		if (this.props.help) {
			return (
				<span className="help-block">{this.props.help}</span>
			);
		}

		return null;
	};

    renderElement = function() {
        let self = this;

        let className = 'form-control';
        if (['range'].indexOf(this.props.type) !== -1) {
            className = null;
        }

		let propsCopy = JSON.parse(JSON.stringify(this.props));

		delete propsCopy.htmlHelp;

        return React.createElement('input', _extends({
            ref: function ref(c) {
				self.element = c;
                return self.element;
            },
            className: className
        }, cleanProps(propsCopy), {
            id: this.getId(),
            value: this.getValue(),
            onChange: this.changeValue,
            disabled: this.isFormDisabled() || this.props.disabled
        }));
    };

	render() {
        let element = this.renderElement();

        if (this.props.type === 'hidden') {
            return element;
        }

        if (this.props.addonBefore || this.props.addonAfter || this.props.buttonBefore || this.props.buttonAfter) {
            element = this.renderInputGroup(element);
        }

        if (this.getLayout() === 'elementOnly') {
            return element;
        }

        let warningIcon = null;
        if (this.showErrors()) {
            warningIcon = React.createElement(Icon, { symbol: 'remove', className: 'form-control-feedback' });
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            element,
            warningIcon,
            this.renderHelp(),
            this.renderErrorMessage()
        );
    }
}
